export default "__VITE_ASSET__DKsV9iDK__"